export const APIFetchNoAuth = <T extends Record<string, any>>(
  backend: string
): ((url: string, reqInit: RequestInit) => Promise<T>) => {
  return async (url: string, reqInit: RequestInit) => {
    const res = await fetch(`${backend}${url}`, reqInit);
    if (!res.ok) {
      let errorMessage;
      // Read the body ONCE as text. This consumes the stream.
      const errorBodyAsText = await res.text();
      try {
        // Attempt to parse the retrieved text as JSON.
        const errorData = JSON.parse(errorBodyAsText);
        // Check for common error fields in JSON, fall back to the full text if not found or if parsing failed.
        errorMessage = errorData.error || errorData.message || errorBodyAsText;
      } catch (e) {
        // If JSON.parse fails, it means the body was not JSON. Use the raw text.
        errorMessage = errorBodyAsText;
      }
      throw new Error(`HTTP error ${res.status}: ${errorMessage}`);
    }
    const json = await res.json();
    return json as T;
  };
};

export const AuthorizedFetch = <T extends Record<string, any>>(
  backendApi: string,
  token: string
): ((url: string, reqInit: RequestInit) => Promise<T>) => {
  return baseFetch<T>(backendApi, (r) => {
    r.headers = {
      ...r.headers,
      Authorization: `Bearer ${token}`,
    };
  });
};

export const baseFetch = <T extends Record<string, any>>(
  backendApi: string,
  modifyReq?: (r: RequestInit) => void
): ((url: string, reqInit: RequestInit) => Promise<T>) => {
  return async (url: string, reqInit: RequestInit) => {
    if (modifyReq) {
      modifyReq(reqInit);
    }

    const res = await fetch(`${backendApi}${url}`, reqInit);
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json.message);
    }

    return json as T;
  };
};
